"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function notEmpty(value) {
    return value !== null;
}
function filterNulls(array) {
    return array.filter(notEmpty);
}
exports.default = filterNulls;
